import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import AgreementsCreateForm from "./create";
import AgreementsEditForm from "./edit";
import { AgreementDetailDto, AgreementDto } from "src/store/agreements/type";
import {
  deleteAgreementSaga,
  getAgreementDetailsSaga,
  getAgreementListSaga,
} from "src/store/agreements/saga";

const AgreementsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<AgreementDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<AgreementDetailDto>();
  const columns = [
    {
      text: t("Agreements.Type"),
      dataField: "ClientContractType",
    },
    {
      text: t("Agreements.Title"),
      dataField: "Title",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Agreements.PageTitle")}
        metaTag={t("Agreements.MetaTag")}
        gridProps={{
          addTitle: t("Agreements.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getAgreementListSaga,
          // onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getAgreementDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          // deleteButton: {
          //   text: (id, data: AgreementDto) =>
          //     t("Agreements.DeleteQA", {
          //       name: data.Title,
          //     }),
          //   action: deleteAgreementSaga,
          //   onClick: (id, data) => setShowEdit(data),
          // },
        }}
      />
      <AgreementsCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getAgreementListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <AgreementsEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getAgreementListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default AgreementsPage;
